import { splitBowlerName } from "./bowlerName";

export const normalizeMatchName = (name) =>
  (name || "")
    .toLowerCase()
    .replace(/[.]/g, "")
    .replace(/,/g, " ")
    .replace(/\s+/g, " ")
    .trim();

export const normalizeUsbcId = (value) => {
  const digits = String(value || "").replace(/\D/g, "");
  return digits.length >= 6 ? digits : "";
};

export const nameKey = (name) => normalizeMatchName(name);

export const lastFirstKey = (name) => {
  const { firstName, lastName } = splitBowlerName(name);
  return `${normalizeMatchName(lastName)}\t${normalizeMatchName(firstName)}`;
};

export const uniqueIndex = (items, keyFor) => {
  const buckets = new Map();
  for (const item of items) {
    const key = keyFor(item);
    if (!key) continue;
    const group = buckets.get(key) || [];
    group.push(item);
    buckets.set(key, group);
  }
  const unique = new Map();
  for (const [key, group] of buckets.entries()) {
    if (group.length === 1) unique.set(key, group[0]);
  }
  return { unique, buckets };
};
